module.exports = __webpack_public_path__ + "static/lyndsey-31ab8cc5029375d2172fef1638a47790.png";